import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import { ApolloLink } from "apollo-link";
import VueApollo from "vue-apollo";
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { Message } from "element-ui";

Vue.use(VueApollo);

let token = localStorage.getItem("token");
Object.defineProperty(Vue.prototype, "$token", {
  get() {
    return token;
  },
  set(value) {
    token = value;
  }
});

// -- Setup URI + Authorization
const authorizedFetch = function(uri, options) {
  options.headers.Authorization = `Bearer ${token}`;
  return fetch(uri, options);
};

let uri = "";
switch (location.hostname) {
  case "swipe-admin.netlify.app":
    uri = "https://swipebill--production.herokuapp.com/graphql";
    break;
  case "swipe-admin-staging.netlify.app":
    uri = "https://swipebill--staging.herokuapp.com/graphql";
    break;
  default:
    uri = "http://localhost:3000/graphql";
    break;
}

const httpLink = createHttpLink({ uri, fetch: authorizedFetch });

// -- Setup error handling and unauthorization logging out

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    if (graphQLErrors[0].message == "Unauthorized") {
      Message({
        message: "Session expired. Please log in again.",
        type: "info",
        duration: 7000
      });
      store.dispatch("logout");
      router.push("/login");
    }
  }
});

const link = ApolloLink.from([errorLink, httpLink]);
const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    uri,
    link,
    cache: new InMemoryCache(),
    queryDeduplication: true
  })
});

export default apolloProvider;
